import { useTranslation } from 'react-i18next'

const AboutToken = () => {
    const { t } = useTranslation();

    return (
        <div className="w-full glass-morphism p-10 md:p-14 rounded-3xl flex flex-col gap-10 relative overflow-hidden mb-12 border border-brand-gold/20 gold-glow">
            {/* Background glowing sweep */}
            <div className="absolute top-0 right-0 w-2/3 h-full bg-gradient-to-l from-brand-gold/10 to-transparent pointer-events-none blur-3xl rounded-3xl"></div>

            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 relative z-10">
                <div className="flex items-center gap-6">
                    <div className="size-16 bg-gradient-to-br from-brand-gold/40 to-brand-gold/10 border border-brand-gold/30 rounded-2xl flex items-center justify-center shadow-[0_0_30px_rgba(234,179,8,0.2)]">
                        <span className="material-symbols-outlined text-brand-gold text-4xl">monitoring</span>
                    </div>
                    <div>
                        <h3 className="text-4xl font-black text-white tracking-tight">{t("aboutToken.title")}</h3>
                        <p className="text-brand-gold/80 font-medium text-lg uppercase tracking-widest mt-1">{t("aboutToken.tokenName")} (AANAND)</p>
                    </div>
                </div>
                <div className="text-left md:text-right mt-6 md:mt-0 p-6 bg-white/5 rounded-2xl border border-white/10 min-w-[240px]">
                    <p className="text-sm text-slate-400 mb-2 uppercase tracking-wider font-bold">{t("aboutToken.contract") || "Contract Address"}</p>
                    <div className="flex items-center justify-start md:justify-end gap-3 mt-1">
                        <p className="text-lg md:text-xl font-mono text-brand-gold bg-brand-gold/10 px-4 py-2 rounded-xl border border-brand-gold/20">
                            0x1b4A7...2f829
                        </p>
                        <button
                            className="h-11 w-11 flex items-center justify-center bg-white/5 hover:bg-white/20 hover:text-brand-gold rounded-xl transition-all border border-white/10"
                            onClick={() => navigator.clipboard.writeText("0x1b4A74e55b9C8DFf5f1D6C58B1d3991E08BFb42f829")}
                            title="Copy Address"
                        >
                            <span className="material-symbols-outlined text-[20px]">content_copy</span>
                        </button>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-10 border-t border-brand-gold/20 relative z-10">
                <div className="bg-white/5 p-6 border border-white/10 rounded-2xl hover:border-brand-gold/50 hover:bg-white/10 transition-all duration-300 transform hover:-translate-y-1">
                    <p className="text-xs text-slate-400 mb-2 uppercase tracking-widest font-bold">{t("aboutToken.symbol")}</p>
                    <p className="text-2xl font-black text-white">AND</p>
                </div>
                <div className="bg-white/5 p-6 border border-white/10 rounded-2xl hover:border-brand-gold/50 hover:bg-white/10 transition-all duration-300 transform hover:-translate-y-1">
                    <p className="text-xs text-slate-400 mb-2 uppercase tracking-widest font-bold">{t("aboutToken.protocol")}</p>
                    <p className="text-2xl font-black text-white">ERC20</p>
                </div>
                <div className="bg-white/5 p-6 border border-white/10 rounded-2xl hover:border-brand-gold/50 hover:bg-white/10 transition-all duration-300 transform hover:-translate-y-1">
                    <p className="text-xs text-slate-400 mb-2 uppercase tracking-widest font-bold">{t("aboutToken.totalSupply")}</p>
                    <p className="text-2xl font-black text-white">1,000,000,000</p>
                </div>
                <div className="bg-white/5 p-6 border border-white/10 rounded-2xl hover:border-brand-gold/50 hover:bg-white/10 transition-all duration-300 transform hover:-translate-y-1">
                    <p className="text-xs text-slate-400 mb-2 uppercase tracking-widest font-bold">{t("aboutToken.type")}</p>
                    <p className="text-lg md:text-xl font-black text-brand-gold uppercase tracking-wider">{t("aboutToken.utilityToken")}</p>
                </div>
            </div>
        </div>
    );
};

export default AboutToken